import axios from "axios";
import { admission, site } from "../../config/api";
import { Button } from "evergreen-ui";
import React from "react";
import { FaNewspaper } from "react-icons/fa";
import { useStatusContent } from "../../config/roundContent";

function NewsDetail({ TYPE, MAJOR, ROB, REGISTER_STATUS }) {
  const { statusContent } = useStatusContent(ROB, REGISTER_STATUS ?? "1");

  const GetNews = async (type, major, rob) => {
    try {
      if (major === "9903") {
        type = "0";
      }
      const fetch = await axios.post(admission + "/student/getNews", {
        type: type,
        major: major,
        rob_id: rob,
      });
      const resp = fetch.data;
      if (resp === null) {
        return 0;
      }
      let t = "0";
      if (type === "1" || type === "5") {
        t = "1";
      } else if (type === "2" || type === "3") {
        t = "2";
      } else if (type === "4" || type === "7") {
        t = "3";
      } else if (type === "6") {
        t = "5";
      } else if (type === "0") {
        t = "0";
      }
      return site + "/admission/News/" + t;
    } catch (error) {
      return 0;
    }
  };

  if (!statusContent.announceVisible) {
    return null;
  }

  return (
    <div>
      <Button
        onClick={() => {
          if (statusContent.announceUrl) {
            window.open(statusContent.announceUrl, "_blank");
            return;
          }
          GetNews(TYPE, MAJOR, ROB).then((res) => {
            if (res !== 0) {
              window.open(res);
            }
          });
        }}
        iconBefore={<FaNewspaper />}
        minWidth={133}
        marginTop={8}
        appearance="primary"
      >
        ดูประกาศ
      </Button>
    </div>
  );
}

export default NewsDetail;
